import { DateTime } from 'luxon';

export const convertDateTime = (dateTimeString: string): string => {
  const parsedDate = new Date(dateTimeString);
  const isoDate = DateTime.fromJSDate(parsedDate, { zone: 'utc' });
  return isoDate.toFormat('LLL d, yyyy hh:mm:ss a');
};
